<template>
  <table class="uk-table table-border uk-table-small">
    <tbody>
      <tr v-for="specs in this.activeProduct.specifications">
        <td class="d-flex align-items-center ps-0">
          <!-- <?php if ($spec_parent->first()->filter_description) { ?> -->
          <i
            class="fa-solid fa-circle-info me-2 text--primary"
            :uk-tooltip="specs[0]['filter_name']"
          ></i>
          <p class="my-0">{{ specs[0]["filter_name"] }}</p>
        </td>

        <td class="pe-0 uk-text-right">
          <span v-for="spec in specs"> {{ spec["name"] }} <br /> </span>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { EventBus } from "../EventBus";
import ProductOverviewPagination from "./ProductOverviewPagination";
import * as functions from "../functions.js";

export default {
  name: "ProductSpecifications",
  components: { ProductOverviewPagination },
  mounted() {
    EventBus.$on("PRODUCT_CHANGED", (product) => {
      this.activeProduct = product;
      //   this.handleChange(product);
    });
  },
  data() {
    return {
      activeProduct: this.product,
    };
  },
  methods: {},
  props: {
    product: {
      type: Object | Array,
      required: true,
    },
  },
};
</script>

<style scoped>
</style>